module.exports = __webpack_public_path__ + "static/img/8.558d6ecf.png";